import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import { LocaleId } from './constants/general';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      order: ['cookie'],
    },
    caches: ['cookie'],
    fallbackLng: LocaleId.EN,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
